import { TArrayTypeId as TArrayTypeId$1, collectFirst as collectFirst$1, collectFirstSTM as collectFirstSTM$1, contains as contains$1, count as count$1, countSTM as countSTM$1, empty as empty$1, every as every$1, everySTM as everySTM$1, findFirst as findFirst$1, findFirstIndex as findFirstIndex$1, findFirstIndexFrom as findFirstIndexFrom$1, findFirstIndexWhere as findFirstIndexWhere$1, findFirstIndexWhereFrom as findFirstIndexWhereFrom$1, findFirstIndexWhereSTM as findFirstIndexWhereSTM$1, findFirstIndexWhereFromSTM as findFirstIndexWhereFromSTM$1, findFirstSTM as findFirstSTM$1, findLast as findLast$1, findLastIndex as findLastIndex$1, findLastIndexFrom as findLastIndexFrom$1, findLastSTM as findLastSTM$1, forEach as forEach$1, fromIterable as fromIterable$1, get as get$1, headOption as headOption$1, lastOption as lastOption$1, make as make$1, maxOption as maxOption$1, minOption as minOption$1, reduce as reduce$1, reduceOption as reduceOption$1, reduceOptionSTM as reduceOptionSTM$1, reduceSTM as reduceSTM$1, size as size$1, some as some$1, someSTM as someSTM$1, toArray as toArray$1, transform as transform$1, transformSTM as transformSTM$1, update as update$1, updateSTM as updateSTM$1 } from '../../internal/stm/tArray.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const TArrayTypeId = TArrayTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @internal
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/**
 * Finds the result of applying a partial function to the first value in its
 * domain.
 *
 * @since 2.0.0
 * @category elements
 */
const collectFirst = collectFirst$1;

/**
 * Finds the result of applying an transactional partial function to the first
 * value in its domain.
 *
 * @since 2.0.0
 * @category elements
 */
const collectFirstSTM = collectFirstSTM$1;

/**
 * Determine if the array contains a specified value.
 *
 * @macro trace
 * @since 2.0.0
 * @category elements
 */
const contains = contains$1;

/**
 * Count the values in the array matching a predicate.
 *
 * @macro trace
 * @since 2.0.0
 * @category folding
 */
const count = count$1;

/**
 * Count the values in the array matching a transactional predicate.
 *
 * @macro trace
 * @since 2.0.0
 * @category folding
 */
const countSTM = countSTM$1;

/**
 * Makes an empty `TArray`.
 *
 * @since 2.0.0
 * @category constructors
 */
const empty = empty$1;

/**
 * Atomically evaluate the conjunction of a predicate across the members of
 * the array.
 *
 * @since 2.0.0
 * @category elements
 */
const every = every$1;

/**
 * Atomically evaluate the conjunction of a transactional predicate across the
 * members of the array.
 *
 * @since 2.0.0
 * @category elements
 */
const everySTM = everySTM$1;

/**
 * Find the first element in the array matching the specified predicate.
 *
 * @since 2.0.0
 * @category elements
 */
const findFirst = findFirst$1;

/**
 * Get the first index of a specific value in the array.
 *
 * @since 2.0.0
 * @category elements
 */
const findFirstIndex = findFirstIndex$1;

/**
 * Get the first index of a specific value in the array starting from the
 * specified index.
 *
 * @since 2.0.0
 * @category elements
 */
const findFirstIndexFrom = findFirstIndexFrom$1;

/**
 * Get the index of the first entry in the array matching a predicate.
 *
 * @since 2.0.0
 * @category elements
 */
const findFirstIndexWhere = findFirstIndexWhere$1;

/**
 * Get the index of the first entry in the array starting from the specified
 * index, matching a predicate.
 *
 * @since 2.0.0
 * @category elements
 */
const findFirstIndexWhereFrom = findFirstIndexWhereFrom$1;

/**
 * Get the index of the next entry that matches a transactional predicate.
 *
 * @since 2.0.0
 * @category elements
 */
const findFirstIndexWhereSTM = findFirstIndexWhereSTM$1;

/**
 * Starting at specified index, get the index of the next entry that matches a
 * transactional predicate.
 *
 * @since 2.0.0
 * @category elements
 */
const findFirstIndexWhereFromSTM = findFirstIndexWhereFromSTM$1;

/**
 * Find the first element in the array matching a transactional predicate.
 *
 * @since 2.0.0
 * @category elements
 */
const findFirstSTM = findFirstSTM$1;

/**
 * Find the last element in the array matching a predicate.
 *
 * @since 2.0.0
 * @category elements
 */
const findLast = findLast$1;

/**
 * Get the last index of a specific value in the array bounded above by a
 * specific index.
 *
 * @since 2.0.0
 * @category elements
 */
const findLastIndex = findLastIndex$1;

/**
 * Get the last index of a specific value in the array bounded above by a
 * specific index.
 *
 * @since 2.0.0
 * @category elements
 */
const findLastIndexFrom = findLastIndexFrom$1;

/**
 * Find the last element in the array matching a transactional predicate.
 *
 * @since 2.0.0
 * @category elements
 */
const findLastSTM = findLastSTM$1;

/**
 * Atomically performs transactional effect for each item in array.
 *
 * @since 2.0.0
 * @category elements
 */
const forEach = forEach$1;

/**
 * Makes a new `TArray` initialized with provided iterable.
 *
 * @since 2.0.0
 * @category constructors
 */
const fromIterable = fromIterable$1;

/**
 * Extracts value from ref in array.
 *
 * @since 2.0.0
 * @category elements
 */
const get = get$1;

/**
 * The first entry of the array, if it exists.
 *
 * @since 2.0.0
 * @category elements
 */
const headOption = headOption$1;

/**
 * The last entry in the array, if it exists.
 *
 * @since 2.0.0
 * @category elements
 */
const lastOption = lastOption$1;

/**
 * Makes a new `TArray` that is initialized with specified values.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * Atomically compute the greatest element in the array, if it exists.
 *
 * @since 2.0.0
 * @category elements
 */
const maxOption = maxOption$1;

/**
 * Atomically compute the least element in the array, if it exists.
 *
 * @since 2.0.0
 * @category elements
 */
const minOption = minOption$1;

/**
 * Atomically folds using a pure function.
 *
 * @since 2.0.0
 * @category folding
 */
const reduce = reduce$1;

/**
 * Atomically reduce the array, if non-empty, by a binary operator.
 *
 * @since 2.0.0
 * @category elements
 */
const reduceOption = reduceOption$1;

/**
 * Atomically reduce the non-empty array using a transactional binary
 * operator.
 *
 * @since 2.0.0
 * @category elements
 */
const reduceOptionSTM = reduceOptionSTM$1;

/**
 * Atomically folds using a transactional function.
 *
 * @macro trace
 * @since 2.0.0
 * @category folding
 */
const reduceSTM = reduceSTM$1;

/**
 * Returns the size of the `TArray`.
 *
 * @since 2.0.0
 * @category getters
 */
const size = size$1;

/**
 * Determine if the array contains a value satisfying a predicate.
 *
 * @since 2.0.0
 * @category elements
 */
const some = some$1;

/**
 * Determine if the array contains a value satisfying a transactional
 * predicate.
 *
 * @since 2.0.0
 * @category elements
 */
const someSTM = someSTM$1;

/**
 * Collects all elements into a chunk.
 *
 * @since 2.0.0
 * @since 2.0.0
 * @category destructors
 */
const toArray = toArray$1;

/**
 * Atomically updates all elements using a pure function.
 *
 * @since 2.0.0
 * @category elements
 */
const transform = transform$1;

/**
 * Atomically updates all elements using a transactional effect.
 *
 * @since 2.0.0
 * @category elements
 */
const transformSTM = transformSTM$1;

/**
 * Updates element in the array with given function.
 *
 * @since 2.0.0
 * @category elements
 */
const update = update$1;

/**
 * Atomically updates element in the array with given transactional effect.
 *
 * @since 2.0.0
 * @category elements
 */
const updateSTM = updateSTM$1;

export { TArrayTypeId, collectFirst, collectFirstSTM, contains, count, countSTM, empty, every, everySTM, findFirst, findFirstIndex, findFirstIndexFrom, findFirstIndexWhere, findFirstIndexWhereFrom, findFirstIndexWhereFromSTM, findFirstIndexWhereSTM, findFirstSTM, findLast, findLastIndex, findLastIndexFrom, findLastSTM, forEach, fromIterable, get, headOption, lastOption, make, maxOption, minOption, reduce, reduceOption, reduceOptionSTM, reduceSTM, size, some, someSTM, toArray, transform, transformSTM, update, updateSTM };
